import { isTabAllowed } from '@revelio/auth';
import { Tab } from '@revelio/data-access';

export type GlobalAssistantAccessDecision =
  | { allowed: true }
  | {
      allowed: false;
      featureLabel: string;
      message: string;
    };

const INACCESSIBLE_MESSAGE = (featureLabel: string) =>
  `You do not have access to ${featureLabel}. Please contact sales to upgrade.`;

const ROUTE_ACCESS_BY_SEGMENT: Record<
  string,
  { tab: Tab; featureLabel: string }
> = {
  compositions: { tab: Tab.Overview, featureLabel: 'Compositions' },
  'sentiment-ratings': { tab: Tab.Sentiment, featureLabel: 'Sentiment' },
  sentiment: { tab: Tab.Sentiment, featureLabel: 'Sentiment' },
  postings: { tab: Tab.Posting, featureLabel: 'Job Postings' },
  pay: { tab: Tab.Compensation, featureLabel: 'Pay' },
  screener: { tab: Tab.Screener, featureLabel: 'Screener' },
  summary: { tab: Tab.EntitySummary, featureLabel: 'Summary' },
  transitions: { tab: Tab.Transition, featureLabel: 'Transitions' },
};

function deny(featureLabel: string): GlobalAssistantAccessDecision {
  return {
    allowed: false,
    featureLabel,
    message: INACCESSIBLE_MESSAGE(featureLabel),
  };
}

export function getGlobalAssistantRouteAccess(
  navigatePath: string,
  userTabs: Tab[] = []
): GlobalAssistantAccessDecision {
  const segments = navigatePath.split('/').filter(Boolean);
  const [firstSegment, secondSegment] = segments;

  if (segments.length === 1 && firstSegment === 'talent-discovery') {
    return isTabAllowed(Tab.TalentDiscovery, userTabs)
      ? { allowed: true }
      : deny('Individual Discovery');
  }

  const routeAccess =
    secondSegment === undefined
      ? undefined
      : ROUTE_ACCESS_BY_SEGMENT[secondSegment];

  if (!routeAccess) {
    return { allowed: true };
  }

  return isTabAllowed(routeAccess.tab, userTabs)
    ? { allowed: true }
    : deny(routeAccess.featureLabel);
}

export function getGlobalAssistantCustomDashAccess(
  customDashEnabled: boolean
): GlobalAssistantAccessDecision {
  return customDashEnabled ? { allowed: true } : deny('Custom Dash');
}
